module.exports = __webpack_public_path__ + "static/media/logo_transparent_blue.2ee430ce.png";